import DiagramType from "@core/components/Diagram/DiagramType";
import { parseScale } from "@ext/markdown/elements/diagrams/logic/getAttrs";
import parseDiagramInfo from "@ext/markdown/elements/diagrams/logic/parseDiagramInfo";

const getFencedDiagramAttrs = (language: string, content: string) => {
	const { name, attrs } = parseDiagramInfo(language);
	return {
		content,
		diagramName: DiagramType[name],
		title: attrs.title,
		float: attrs.float,
		scale: parseScale(attrs.scale),
	};
};

export default getFencedDiagramAttrs;
